import _styled from "@emotion/styled/base";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { keyframes, useTheme } from '@emotion/react';
import { forwardRef, useImperativeHandle, useRef, useState } from 'react';
import ReactSelect from 'react-select';
import { Control } from '../../primitives/Select/components/Control/index.js';
import { DropdownIndicator } from '../../primitives/Select/components/DropdownIndicator.js';
import { MenuList } from '../../primitives/Select/components/MenuList.js';
import { Option } from '../../primitives/Select/components/Option/index.js';
import { Placeholder } from '../../primitives/Select/components/Placeholder/index.js';
import { SelectContainer } from '../../primitives/Select/components/SelectContainer.js';
import { SingleValue } from '../../primitives/Select/components/SingleValue/index.js';
import { ValueContainer } from '../../primitives/Select/components/ValueContainer/index.js';
const customStyles = {
  container: (provided, state) => {
    const highlight = keyframes`
      from {
        outline-color: ${state.theme.app.colors.backgroundPrimary};
      }
      to {
        outline-color: ${state.theme.app.colors.systemWarning};
      }
    `;
    return {
      ...provided,
      minWidth: '0',
      borderRadius: '5px',
      outline: '2px solid transparent',
      ...(state.selectProps.highlighted && {
        animation: `${highlight} 0.5s forwards`
      }),
      ...(state.selectProps.fullWidth && {
        width: '100%'
      })
    };
  },
  indicatorSeparator: () => ({
    display: 'none'
  }),
  // @ts-expect-error TS(7006) FIXME: Parameter 'provided' implicitly has an 'any' type.
  menu: (provided, state) => ({
    ...provided,
    borderRadius: '5px',
    boxShadow: '0px 0px 24px rgba(0, 0, 0, 0.08), 0px 8px 24px rgba(0, 0, 0, 0.1)',
    zIndex: state.theme.app.stacking.zIndexControlsPriority
  }),
  // @ts-expect-error TS(7006) FIXME: Parameter 'provided' implicitly has an 'any' type.
  group: (provided, state) => ({
    '& + &': {
      borderTop: `1px solid ${state.theme.app.colors.borderSecondary}`
    }
  }),
  groupHeading: () => ({
    display: 'none'
  }),
  input: provided => ({
    ...provided,
    margin: 0,
    padding: 0,
    // This is making the input element wrapper div with the inline `inline-block` style explicitly set by React Select fit correctly in our layout
    lineHeight: '1rem'
  }),
  // @ts-expect-error TS(7006) FIXME: Parameter 'provided' implicitly has an 'any' type.
  dropdownIndicator: (provided, state) => ({
    ...provided,
    padding: '0',
    ...(state.isDisabled ? {
      color: state.theme.app.colors.contentStateDisabled
    } : {
      color: state.theme.app.colors.interactionSecondary,
      '&:hover': {
        color: state.theme.app.colors.interactionSecondary
      }
    })
  })
};
export const Select = /*#__PURE__*/_styled(forwardRef(function Select(props, ref) {
  const {
    styles,
    components,
    message,
    pinnedPlaceholder = false,
    invalid = false,
    highlighted: controlledHighlighted,
    size = 'medium',
    highlightBehaviour = 'onFocus',
    centered = false,
    disabled,
    customMenuListHeight,
    menuShouldScrollIntoView,
    onMenuOpen,
    id,
    controlIcon,
    dropdownIndicatorIcon,
    formatSingleValue,
    menuListProps
  } = props;
  const appTheme = useTheme();
  const selectRef = useRef();
  const [highlighted, setHighlighted] = useState(false);
  const selectProps = {
    ...props,
    isPinned: pinnedPlaceholder,
    highlighted: controlledHighlighted == null ? highlighted : controlledHighlighted,
    size,
    invalid,
    message,
    highlightBehaviour,
    centered,
    controlIcon,
    dropdownIndicatorIcon,
    formatSingleValue,
    menuListProps
  };
  useImperativeHandle(ref, () => ({
    focus: () => {
      selectRef.current.focus();
    },
    highlightOn: () => {
      setHighlighted(true);
    },
    highlightOff: () => {
      setHighlighted(false);
    }
  }));
  return _jsx(ReactSelect, {
    ...selectProps,
    ref: selectRef,
    styles: {
      ...customStyles,
      menuList: provided => ({
        ...provided,
        height: customMenuListHeight
      }),
      ...styles
    },
    components: {
      Control,
      SingleValue,
      Option,
      Placeholder,
      ValueContainer,
      SelectContainer,
      DropdownIndicator,
      MenuList,
      ...components
    },
    // Make our own theme available inside React Select styling callbacks
    theme: theme => ({
      ...theme,
      app: appTheme
    }),
    isDisabled: disabled,
    menuShouldScrollIntoView: menuShouldScrollIntoView,
    onMenuOpen: onMenuOpen,
    inputId: id
  });
}), process.env.NODE_ENV === "production" ? {
  target: "evxrh3v0"
} : {
  target: "evxrh3v0",
  label: "Select"
})(process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");